module.exports = __webpack_public_path__ + "img/Tessellate04.d1ae5121.png";